export const POPUP_STATE_NAME = 'popup';

export const SESSION_STORAGE_WELCOME_POPUP = 'welcome_popup';
export const LOCAL_STORAGE_VISIT_WELCOME_PAGE = 'visit_welcome_page';
